import { 
  Directive, Input, ElementRef, HostListener, EmbeddedViewRef,
  ComponentRef, ApplicationRef, ComponentFactoryResolver, Injector,
  OnInit, OnDestroy
} from '@angular/core';
import { UtilsService } from '@jit/core';
import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  selector: '[jitTooltip]',
  standalone: true,
})
class TooltipDirective implements OnInit, OnDestroy {
  
  @Input('jitTooltip')
  tooltip: string = '';
  
  private _componentRef: ComponentRef<any> | null = null;
  private _listener: any = null;

  constructor(
    private _elementRef: ElementRef,
  	private _appRef: ApplicationRef, 
	  private _componentFactoryResolver: ComponentFactoryResolver,
	  private _injector: Injector
  ) {}

  ngOnInit(): void {
    this._listener = UtilsService.debounce(() => (this.destroy()), 10);
  
    window.addEventListener('resize', this._listener, true);
    window.addEventListener('scroll', this._listener, true);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this._listener);
    window.removeEventListener('scroll', this._listener);
    
    this.destroy();

    this._listener = null;
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this._componentRef === null) {
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(TooltipComponent);

      this._componentRef = componentFactory.create(this._injector);

      this._appRef.attachView(this._componentRef.hostView);
      
      const domElem = (this._componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;       
      
      document.body.appendChild(domElem);
      
      this.setProps();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  setProps() {
    if (this._componentRef !== null) {
      this._componentRef.instance.tooltip = this.tooltip;

      const parentRect = this._elementRef.nativeElement.getBoundingClientRect();
      const innerWidth: number = window.innerWidth;
      const width: number = 180;

      let left: number = parentRect.x;

      if (left + width > innerWidth) {
        left = left - ((left + width) - (innerWidth - 26));
      } else {
        // 15px is triangle position relative to tooltip
        left = left - width + (parentRect.width / 2) + 15;
      }

      this._componentRef.instance.position = { 
        left: left,
        top: Math.round(parentRect.top),
      };
    }
  }

  destroy(): void {
    if (this._componentRef !== null) {
      this._appRef.detachView(this._componentRef.hostView);
      this._componentRef.destroy();
      
      this._componentRef = null;
    }
  }

}

export {
  TooltipDirective,
};
